<template>
  <v-app id="app"
         :style="{ background: $vuetify.theme.currentTheme.background }">
    <Navbar />
    <v-main class="mb-4">
      <router-view id="routerView" />
    </v-main>

    <v-footer app>
      <Footer />
    </v-footer>

    <!-- Data Sync -->
    <DataSyncNotification />

    <!-- Deck Space Calculating-->
    <CalculatingDeckSpaceNotification />

    <!-- Update Notification -->
    <v-snackbar top right :value="updateExists" :timeout="-1" color="primary">
      An Update is Available
      <template v-slot:action>
        <v-btn text @click="refreshApp"> Update </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';
  import Navbar from './components/ui/Navbar.vue';
  import Footer from './components/ui/Footer.vue';
  import DataSyncNotification from './components/ui/DataSyncNotification.vue';
  import CalculatingDeckSpaceNotification from './components/ui/CalculatingDeckSpaceNotification.vue';
  import SWUpdateMixin from './mixins/SWUpdateMixin';

  export default {
    mixins: [SWUpdateMixin],
    components: { Navbar, Footer, DataSyncNotification, CalculatingDeckSpaceNotification },
    computed: {
      ...mapState(['userStore']),
      ...mapGetters({
        isUserLoggedIn: 'userStore/isUserLoggedIn',
        activeSiteId: 'userStore/getActiveSiteId'
      }),
    },
    created() {
      if (!this.isUserLoggedIn) {
        const currentUser = JSON.parse(localStorage.getItem('user'));
        if (currentUser) {
          this.$store.dispatch('userStore/setUserFromLocalStorage', currentUser);
          this.$store.dispatch('userStore/checkUserValidity')
            .then(() => this.$store.dispatch('userStore/reloadUserData', this.activeSiteId));
        }
      } else {
        this.$store.dispatch('userStore/checkUserValidity')
          .then(() => this.$store.dispatch('userStore/reloadUserData', this.activeSiteId));
      }
    },
  };
</script>

<style>
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  #routerView {
    padding: 16px;
  }

  .hidden {
    visibility: hidden;
  }

  .nav-font {
    font-family: "Dosis", sans-serif !important;
  }

  .nav-title {
    font-size: 34px;
    font-weight: bold;
  }

  .theme--light.v-divider {
    border-color: grey !important;
  }
</style>
